import { useState } from "react";
import { useParams } from "react-router-dom";
import api from './../../api/api';
import { Oval } from "react-loader-spinner";
import Confirm from "../Modal/Alert/confirm";

const BroadCast = () =>{
    

    const [body, setBody] = useState(null);
    const [title, setTitle] = useState(null)
    const [loading, setLoading] = useState(false)
    const [type, setType] = useState('ALL')
    const [showAlert, setShowAlert] = useState(false)


    const sendEmail = async ()=>{

        if(body && title){
            
            try {
                setShowAlert(false)
                setLoading(true)
                await api.post('/email/broad', {
                    body, title, type
                })
    
                setLoading(false)
                alert("Message envoyée")


                return;
                
            } catch (error) {
                console.log(error)
            }
        }else{
            
        }
    }


    return (
        <div className="p-5 m-10 bg-white rounded-md shadow-lg dark:bg-gray-800">
          <form>
            <h3 className="mb-4 text-2xl font-bold dark:text-gray-200">Envoyer un message broadcast</h3>
            
            <div className="my-5">
              <label className="block mb-2 dark:text-gray-200">Type :</label>
              <select
                value={type}
                onChange={(event)=>{
                    setType(event.target.value)
                }}
                className="inline w-full px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-purple-700 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
              >
                <option value="OWNER" className="hover:bg-indigo-200">A tous les proprietaires</option>
                <option value="PREMIUM" className="hover:bg-indigo-200">A tous les proprietaires Premium</option>
                <option defaultValue={true} value="ALL" className="hover:bg-indigo-200">A tous les clients</option>
              </select>
            </div>

            <div className="my-5">
              <label className="block mb-2 dark:text-gray-200">Titre :</label>
              <input
                type="text"
                value={title}
                onChange={(event)=>setTitle(event.target.value)}
                className="w-full p-2 mb-4 border border-gray-300 rounded dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                placeholder="Titre"
              />
            </div>
            
            <div className="my-5">
              <label className="block mb-2 dark:text-gray-200">Message :</label>
              <textarea
                className="w-full p-2 mb-4 border border-gray-300 rounded dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                rows="10"
                
                onChange={(event)=>setBody(event.target.value)}
                placeholder="Écrire un message"
              />
            </div>

            
            {!loading ?
                <div onClick={()=>setShowAlert(true)} className="items-center self-center justify-center w-full py-2 text-center text-white bg-indigo-700 rounded-md cursor-pointer hover:bg-indigo-800">
                    <p className="dark:text-gray-200">Envoyer</p>
                </div>
              :
              <div className="flex items-center self-center justify-center m-auto text-center">
                  <Oval
                      height={20}
                      width={20}
                      color="blue"
                      visible={true}
                      ariaLabel="oval-loading"
                      secondaryColor="#cccccc"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                  />
              </div>}
          </form>

          <Confirm
            open={showAlert}
            onClose={()=>setShowAlert(false)}
            onAccept={sendEmail}
            onDecline={()=>setShowAlert(false)}
            message={"Voulez vous vraiment envoyer ce message broadcast ?"}
          />

        </div>
      );
} 


export default BroadCast
